import React, { useEffect } from 'react';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { ValidateCertificate } from './components/ValidateCertificate';
import { Route, Routes } from 'react-router-dom';

import { MagInstitute } from './components/MagInstitute';
import { Home } from './components/Home';


function App() {

  useEffect(() => {
   document.title = "Mag Institure of Maritime Academy"
  }, []);

  return (
    <>
    <Routes>
      <Route path='/' element={<Home />}></Route>
      <Route path='/home' element={<Home />}></Route>
      <Route path='/validateCertificate' element={<ValidateCertificate />}></Route>
    </Routes>
    </>
  );
}

export default App;
